import FacturesPontController from './factures.pont.controller';

export default {
    template: require('./factures.pont.tpl.html'),
    controller: FacturesPontController
};
